import { SVGProps } from 'react';

export const WaveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='38'
    height='38'
    viewBox='0 0 38 38'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g clipPath='url(#clip0_239_22607)'>
      <path
        d='M31.7962 33.6108C31.8424 33.5582 31.8875 33.5047 31.9316 33.4505C33.4779 31.5474 34.099 28.585 34.388 26.2314C34.9932 21.3005 35.6364 17.318 36.9983 15.7629C38.3464 14.2235 32.8741 11.5322 30.5615 18.0258C30.5378 18.0923 30.5144 18.1598 30.4914 18.2283C30.4914 18.2283 24.6277 5.82543 20.1636 4.99099C15.6996 4.15656 21.9921 12.1456 23.5053 14.4214C23.5053 14.4214 17.7929 5.43213 14.1233 6.07692C10.4537 6.72171 17.9442 16.204 17.9442 16.204C17.9442 16.204 11.5382 9.01149 9.6467 10.2252C7.75515 11.4389 13.518 18.2901 13.518 18.2901C13.518 18.2901 9.1549 13.2596 7.71732 13.9802C6.27974 14.7008 8.73874 20.4661 10.4033 23.5763C12.0679 26.6865 11.6895 34.2724 18.5369 35.9792C21.0126 36.5963 23.6269 36.87 26.1542 36.4132C28.1463 36.0532 30.424 35.1766 31.7962 33.6108Z'
        fill='#FFB927'
      />
      <path
        d='M31.7962 33.6108C31.8424 33.5582 31.8875 33.5047 31.9316 33.4505C33.4779 31.5474 34.099 28.585 34.388 26.2314C34.9932 21.3005 35.6364 17.318 36.9983 15.7629C38.3464 14.2235 32.8741 11.5322 30.5615 18.0258C30.5378 18.0923 30.5144 18.1598 30.4914 18.2283C30.4914 18.2283 24.6277 5.82543 20.1636 4.99099C15.6996 4.15656 21.9921 12.1456 23.5053 14.4214C23.5053 14.4214 17.7929 5.43213 14.1233 6.07692C10.4537 6.72171 17.8248 16.0319 17.8248 16.0319C17.8248 16.0319 11.5382 9.01149 9.6467 10.2252C7.75515 11.4389 13.518 18.2901 13.518 18.2901C13.518 18.2901 9.1549 13.2596 7.71732 13.9802C6.27974 14.7008 8.73874 20.4661 10.4033 23.5763C12.0679 26.6865 11.6895 34.2724 18.5369 35.9792C21.0126 36.5963 23.6269 36.87 26.1542 36.4132C28.1463 36.0532 30.424 35.1766 31.7962 33.6108Z'
        stroke='#32313B'
        strokeWidth='0.782353'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M25.7148 14.3042C25.7148 14.3042 17.8839 14.7214 12.285 19.4247'
        stroke='#32313B'
        strokeWidth='0.782353'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M27.2808 23.7104C27.2808 26.712 24.8538 29.1452 21.8601 29.1452C18.8664 29.1452 16.4395 26.712 16.4395 23.7104'
        stroke='#32313B'
        strokeWidth='0.782353'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M19.2742 22.6985C19.7093 22.6985 20.0621 22.3448 20.0621 21.9086C20.0621 21.4723 19.7093 21.1187 19.2742 21.1187C18.8391 21.1187 18.4863 21.4723 18.4863 21.9086C18.4863 22.3448 18.8391 22.6985 19.2742 22.6985Z'
        fill='#32313B'
      />
      <path
        d='M24.1292 22.6985C24.5643 22.6985 24.9171 22.3448 24.9171 21.9086C24.9171 21.4723 24.5643 21.1187 24.1292 21.1187C23.6941 21.1187 23.3413 21.4723 23.3413 21.9086C23.3413 22.3448 23.6941 22.6985 24.1292 22.6985Z'
        fill='#32313B'
      />
      <path
        d='M21.6444 1.35938C21.6444 1.35938 27.2723 3.40757 29.0881 7.54185'
        stroke='#32313B'
        strokeWidth='0.782353'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M26.5917 1.35938C26.5917 1.35938 28.4832 2.11795 29.4668 4.01443'
        stroke='#32313B'
        strokeWidth='0.782353'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M7.72754 25.0318C7.72754 25.0318 2.72393 21.7355 1.90977 17.2925'
        stroke='#32313B'
        strokeWidth='0.782353'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M2.91455 23.8859C2.91455 23.8859 1.24897 22.7097 0.728992 20.6367'
        stroke='#32313B'
        strokeWidth='0.782353'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_239_22607'>
        <rect width='38' height='38' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
